export default {
  name: "Orders",
  data() {
    return {
      screenWidth: 0,
      screenHeight: 0,
      heightglobalContainerRouterView:0,
      heightGlobalContent:0,
      texts: "",
    };
  },
  beforeMount() {
    this.texts = FILE.searchbarTexts[this.selectLanguage];
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.heightglobalContainerRouterView  = document.getElementsByClassName("global-container-router-view");
      this.heightGlobalContent = document.getElementsByClassName("global-content");
      if (this.heightglobalContainerRouterView[0] != undefined || this.heightGlobalContent[0] != undefined) {

      }
 
      this.screenHeight = window.innerHeight - 70;
      if (window.innerWidth > 800) {
        this.screenWidth = window.innerWidth - 100;
      }else{
        this.screenWidth = window.innerWidth 
      }
    },
  },
  computed: {
    bMenuSidebar() {
      return this.$store.state.bMenuSidebar;
    },
    selectLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    selectLanguage() {
      if (this.selectLanguage) {
        this.texts = FILE.searchbarTexts[this.selectLanguage];
      }
    },
  },
};